import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const approveWithdrawalRequest = createAsyncThunk(
	'funding/approveWithdrawalRequest',
	async (credentials: any, { rejectWithValue }) => {
		try {
			await AccountService.approveWithdrawal(credentials);
			return await AccountService.withdrawals();
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
